import { useSelector } from 'react-redux';

import { DisplayNameFormatterProps } from '.';
import Language from 'types/LanguageEnum';
import { createDictionary } from 'utils/objectUtils';
import { getSelectedLanguage } from 'modules/translations/selectors';

const computeDisplayName = (args: String[]) => {
  return args.reduce((acc, value) => {
    if (value?.trim()) {
      return [...acc, value?.trim()];
    }
    return acc;
  }, []).join(' ');
};

export const defaultDisplayNameFormatter = (user?: DisplayNameFormatterProps['user']) => (
  user?.displayName || computeDisplayName([user?.firstName, user?.lastName])
);

export const formatDisplayNameLastFirst = (user?: DisplayNameFormatterProps['user']): string => {
  return computeDisplayName([user?.lastName, user?.firstName]) || (user?.displayName ?? '');
};

export const DISPLAY_NAME_FORMATTERS = createDictionary<Language, (user?: DisplayNameFormatterProps['user']) => string>({
  [Language.JA_JP]: formatDisplayNameLastFirst,
  [Language.KO_KR]: formatDisplayNameLastFirst,
  [Language.ZH_TW]: formatDisplayNameLastFirst,
  [Language.ZH_HK]: formatDisplayNameLastFirst,
  [Language.ZH_CN]: formatDisplayNameLastFirst,
}, defaultDisplayNameFormatter);


export const useDisplayNameFormatter = () => {
  const locale = useSelector(getSelectedLanguage);
  return DISPLAY_NAME_FORMATTERS[locale];
};

